/** Phase 20 */
import { listAggregateOfflineQueue } from '../infrastructure/storage/domainAggregateStore';
import { listEntityOfflineQueue } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'offlineQueue',
  listAggregate: listAggregateOfflineQueue,
  listEntity: listEntityOfflineQueue,
  idKeys: ['id', 'outboxId', 'timestamp']
});

export const readOfflineQueueFromMergedBlob = source.readFromMergedBlob;
export const readOfflineQueueFromBestSource = source.readFromBestSource;
export const refreshOfflineQueueReadCache = source.refreshReadCache;
export const getCachedOfflineQueueRead = source.getCachedRead;
export const clearOfflineQueueReadCache = source.clearReadCache;
export const readOfflineQueueSyncForBusiness = source.readSyncForBusiness;
